import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyNetworkIcon } from '@root/entities/currency/ui'
import { CopyButton } from '@root/shared/ui-kit'

import type { ReferralCode } from '../../model'
import type { DeviceType } from '@blade/ui-theme'
import type { Network } from '@root/entities/network'

type ReferralCodeInlineProps = {
  network: Network.Network
  code: ReferralCode
  device?: DeviceType
}

export const ReferralCodeInline: React.FC<ReferralCodeInlineProps> = ({
  code,
  network,
  device = 'desktop',
}) => {
  const isMobile = device === 'mobile'

  return (
    <Root>
      <CurrencyNetworkIcon size={isMobile ? 20 : 16} network={network} />
      <Code variant="body4-medium">{code}</Code>
      <CopyButton size={16} value={code} />
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
`

const Code = styled(Typography)`
  color: var(--text-12);
`
